<template>
  <h1 class="header">
    <div class="logo-wrap">
      <img class="logo" src="../../assets/image/ic_logo.png" />
      <span>{{ $t["title"] }}</span>
    </div>
    <div v-if="logoutShown" class="logout-wrap" @click="logout">
      <a href="javascript:;">{{ $t["logout"] }}</a>
    </div>
  </h1>
</template>
<script>
import { mapMutations } from "vuex";
import { showConfirmDialog } from "vant";
export default {
  props: {
    logoutShown: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["$t"],
  methods: {
    ...mapMutations(["setProfile"]),
    logout() {
      showConfirmDialog({
        message: this.$t.logout,
        confirmButtonText: this.$t.common_confirm,
        cancelButtonText: this.$t.common_cancel,
      }).then(async () => {
        await this.setProfile();
        this.$router.replace({
          name: "login",
          // replace: true,
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  font-family: "SF UI Text Semibold";
  font-size: 0.32rem;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo-wrap {
    flex: 1;
    display: flex;
    align-items: center;

    .logo {
      width: 0.92rem;
      height: 0.92rem;
      vertical-align: middle;
    }
    span {
      margin: 0 0.1rem;
    }
  }

  .logout-wrap {
    font-size: 0.28rem;
    background-color: rgba(1, 172, 255, 0.04);
    border-radius: 0.52rem;
    min-width: 1.2rem;
    text-align: center;
    height: 0.52rem;
    line-height: 0.52rem;
    padding: 0 0.16rem;
    cursor: pointer;

    a {
      color: #01acff;
    }
  }
}
</style>
